
import React from "react";

const CertificationShowcase: React.FC = () => {
  return (
    <section>
      <div>
        {/* Certification Showcase */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-500 rounded-3xl p-12 mb-16 text-center">
          <h3 className="text-3xl font-bold text-white mb-8">
            Certified &amp; Recognized by Leading Organizations
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              "ISO 9001:2015 Certified",
              "STEM.org Accredited",
              "CBSE Approved",
              "Safety Compliant",
            ].map((cert, idx) => (
              <div
                key={idx}
                className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6"
              >
                <i className="ri-verified-badge-fill text-5xl text-yellow-400 mb-3"></i>
                <p className="text-white font-semibold">{cert}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationShowcase;
